module.exports = __webpack_public_path__ + "static/media/search_none_img.f2f5d487.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/search_none_img.png
// module id = 2121
// module chunks = 6